import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file before upload.
 * Default settings aim for high quality but significant size reduction (max 1MB, 1920px width).
 * @param file The original image file
 * @param options optional overrides for compression options
 * @returns Promise resolving to the compressed File
 */
export const compressImage = async (
    file: File,
    options: {
        maxSizeMB?: number;
        maxWidthOrHeight?: number;
        useWebWorker?: boolean;
        initialQuality?: number;
    } = {}
): Promise<File> => {
    // Configuración por defecto
    const defaultOptions = {
        maxSizeMB: 0.8,              // Max file size in MB
        maxWidthOrHeight: 1280,      // Max width/height in pixels
        useWebWorker: true,          // Use web worker for better performance
        initialQuality: 0.7,         // Initial quality (0 to 1)
        fileType: 'image/jpeg'       // Force JPEG for better compression
    };

    const compressionOptions = { ...defaultOptions, ...options };

    try {
        console.warn(`🖼️ Compresión: Original ${(file.size / 1024 / 1024).toFixed(2)} MB`);
        const compressedFile = await imageCompression(file, compressionOptions);
        console.warn(`✅ Compresión: Resultado ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
        return compressedFile;
    } catch (error) {
        console.error('Error compressing image:', error);
        // En caso de error, devolver el archivo original para no bloquear el flujo
        return file;
    }
};
